import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=215f57cc&scoped=true&"
import script from "./Fieldset.vue?vue&type=script&lang=js&"
export * from "./Fieldset.vue?vue&type=script&lang=js&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=215f57cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f57cc",
  null
  
)

export default component.exports